import {
  createCustomCommunication,
  deleteCustomCommunication,
  getCustomCommunicationPreview,
  getCustomCommunications,
  updateCustomCommunication,
} from 'redux/actions/mentorship-program-custom-communications';
import { initialRootState } from '.';
import { createReducer } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { MentorshipProgramCustomCommunicationsSchema } from 'redux/schemas/api/mentorship-program-custom-communications';
import { mergeWith } from 'lodash';
import { replaceArrays } from 'shared/lodash-utils';

const setCustomCommunicationsActionHandler = (state, action) => {
  const normalized = normalize(
    action.payload,
    MentorshipProgramCustomCommunicationsSchema
  );

  mergeWith(state.models, normalized.entities, replaceArrays);
};

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(
      createCustomCommunication.fulfilled,
      (state, action) => {
        const communication = action.payload;
        state.models.mentorshipProgramCustomCommunications[communication.id] = communication;
      }
    )
    .addCase(
      getCustomCommunications.fulfilled,
      setCustomCommunicationsActionHandler
    )
    .addCase(updateCustomCommunication.fulfilled, (state, action) => {
      const { communicationId } = action.meta.arg;
      state.models.mentorshipProgramCustomCommunications[communicationId] =
        action.payload;
    })
    .addCase(deleteCustomCommunication.fulfilled, (state, action) => {
      const { communicationId } = action.meta.arg;
      delete state.models.mentorshipProgramCustomCommunications[
        communicationId
      ];
    })
    .addCase(getCustomCommunicationPreview.fulfilled, (state, action) => {
      const { payload } = action;
      state.app.mentoringProgram.customCommunication.preview = payload;
    });
});
